import {
  OKTA_BASE_URL,
  OKTA_CLIENT_ID,
  OKTA_ISSUER,
  SIGNAL_ENDPOINT_SPHERE,
  SIGNALGRAPHQL_ENDPOINT,
  VERSION_ENDPOINT,
} from '../config';

export type EnvironmentId =
  | 'local'
  | 'ci'
  | 'dogfood'
  | 'beta'
  | 'gamma'
  | 'kappa'
  | 'rho-dev'
  | 'rho'
  | 'iota'
  | 'phi'
  | 'demo';
export type Environment = {
  id: EnvironmentId;
  name: string;
  graphqlUrl: string;
  backendUrl: string;
  oktaIssuer: string;
  oktaBaseUrl: string;
  oktaClientId: string;
  versionApiEndpoint: string;
  frontlineUrl: string;
  idps?: {
    clientId: string;
  }[];
};
export type EnvironmentProp =
  | 'id'
  | 'name'
  | 'graphqlUrl'
  | 'graphqlUrl'
  | 'backendUrl'
  | 'oktaIssuer'
  | 'oktaBaseUrl'
  | 'oktaClientId'
  | 'versionApiEndpoint'
  | 'frontlineUrl';

const localEnv: Environment = {
  id: 'local',
  name: 'local',
  graphqlUrl: 'https://signal-ext.us-west-2.datavinci.dev.plume.tech/graphql/',
  backendUrl: 'https://signal-ext.us-west-2.datavinci.dev.plume.tech',
  oktaIssuer: 'https://external-dev.sso.plume.com/oauth2/default',
  oktaBaseUrl: 'https://external-dev.sso.plume.com',
  oktaClientId: '0oa12oet8abmbyIde0h8',
  versionApiEndpoint:
    'https://signal-ext.us-west-2.datavinci.dev.plume.tech/reports/version',
  frontlineUrl: 'https://ci.noc.plume.com',
};

const environments: Environment[] = [
  localEnv,
  {
    id: 'ci',
    name: 'CI',
    graphqlUrl:
      'https://signal-ext.us-west-2.datavinci.dev.plume.tech/graphql/',
    backendUrl: 'https://signal-ext.us-west-2.datavinci.dev.plume.tech',
    oktaIssuer: 'https://external-dev.sso.plume.com/oauth2/default',
    oktaBaseUrl: 'https://external-dev.sso.plume.com',
    oktaClientId: '0oa12oet8abmbyIde0h8',
    versionApiEndpoint:
      'https://signal-ext.us-west-2.datavinci.dev.plume.tech/reports/version',
    frontlineUrl: 'https://ci.noc.plume.com',
  },
  {
    id: 'dogfood',
    name: 'Dogfood',
    graphqlUrl:
      'https://signal-dog1-ext.us-west-2.datavinci.dev.plume.tech/graphql/',
    backendUrl: 'https://signal-dog1-ext.us-west-2.datavinci.dev.plume.tech',
    oktaIssuer: 'https://external.sso.plume.com/oauth2/default',
    oktaBaseUrl: 'https://external.sso.plume.com',
    oktaClientId: '0oadbipranH3LgmZe357',
    versionApiEndpoint:
      'https://signal-dog1-ext.us-west-2.datavinci.dev.plume.tech/reports/version',
    frontlineUrl: 'https://dogfood.noc.plume.com',
  },
  {
    id: 'beta',
    name: 'Beta',
    graphqlUrl:
      'https://signal-beta-ext.usw2.prod.datavinci.plumenet.io/graphql/',
    backendUrl: 'https://signal-beta-ext.usw2.prod.datavinci.plumenet.io',
    oktaIssuer: 'https://external.sso.plume.com/oauth2/default',
    oktaBaseUrl: 'https://external.sso.plume.com',
    oktaClientId: '0oadbini70Iov4IsU357',
    versionApiEndpoint:
      'https://signal-beta-ext.usw2.prod.datavinci.plumenet.io/reports/version',
    frontlineUrl: 'https://beta.noc.plume.com',
  },
  {
    id: 'gamma',
    name: 'Gamma',
    graphqlUrl:
      'https://signal-gamma-ext.usw2.prod.datavinci.plumenet.io/graphql/',
    backendUrl: 'https://signal-gamma-ext.usw2.prod.datavinci.plumenet.io',
    oktaIssuer: 'https://external.sso.plume.com/oauth2/default',
    oktaBaseUrl: 'https://external.sso.plume.com',
    oktaClientId: '0oadbiqmaw4nafGoX357',
    versionApiEndpoint:
      'https://signal-gamma-ext.usw2.prod.datavinci.plumenet.io/reports/version',
    frontlineUrl: 'https://gamma.noc.plume.com',
  },
  {
    id: 'kappa',
    name: 'Kappa',
    graphqlUrl:
      'https://signal-kappa-ext.euc1.prod.datavinci.plumenet.io/graphql/',
    backendUrl: 'https://signal-kappa-ext.euc1.prod.datavinci.plumenet.io',
    oktaIssuer: 'https://external.sso.plume.com/oauth2/default',
    oktaBaseUrl: 'https://external.sso.plume.com',
    oktaClientId: '0oadbiswq5ZGHwdRI357',
    versionApiEndpoint:
      'https://signal-kappa-ext.euc1.prod.datavinci.plumenet.io/reports/version',
    frontlineUrl: 'https://kappa.noc.plume.com',
  },
  {
    id: 'demo',
    name: 'Demo',
    graphqlUrl:
      'https://signal-demo-ext.us-west-2.dst.global.plume.tech/graphql/',
    backendUrl: 'https://signal-demo-ext.us-west-2.dst.global.plume.tech',
    oktaIssuer: 'https://external.sso.plume.com/oauth2/default',
    oktaBaseUrl: 'https://external.sso.plume.com',
    oktaClientId: '0oadnilc7yYAy4pya357',
    versionApiEndpoint:
      'https://signal-demo-ext.us-west-2.dst.global.plume.tech/reports/version',
    frontlineUrl: 'https://gamma.noc.plume.com',
  },
  {
    id: 'iota',
    name: 'Iota',
    graphqlUrl:
      'https://signal-iota-ext.apne1.prod.datavinci.plumenet.io/graphql/',
    backendUrl: 'https://signal-iota-ext.apne1.prod.datavinci.plumenet.io',
    oktaIssuer: 'https://external.sso.plume.com/oauth2/default',
    oktaBaseUrl: 'https://external.sso.plume.com',
    oktaClientId: '0oa17ggahjtsDDCNw358',
    versionApiEndpoint:
      'https://signal-iota-ext.apne1.prod.datavinci.plumenet.io/reports/version',
    frontlineUrl: 'https://iota.noc.plume.com',
  },
  {
    id: 'phi',
    name: 'Phi',
    graphqlUrl:
      'https://signal-phi-ext.apse1.prod.datavinci.plumenet.io/graphql/',
    backendUrl: 'https://signal-phi-ext.apse1.prod.datavinci.plumenet.io',
    oktaIssuer: 'https://external.sso.plume.com/oauth2/default',
    oktaBaseUrl: 'https://external.sso.plume.com',
    oktaClientId: '0oa1koecepgtBHBcl358',
    versionApiEndpoint:
      'https://signal-phi-ext.apse1.prod.datavinci.plumenet.io/reports/version',
    frontlineUrl: 'https://phi.noc.plume.com',
  },
  {
    id: 'rho-dev',
    name: 'Rho-dev',
    graphqlUrl: 'https://signal.aps1.dev.rho.jiohs.net/graphql/',
    backendUrl: 'https://signal.aps1.dev.rho.jiohs.net',
    oktaIssuer: 'https://external.sso.plume.com/oauth2/default',
    oktaBaseUrl: 'https://external.sso.plume.com',
    oktaClientId: '0oatuf4q61xpPsqTw357',
    versionApiEndpoint: 'https://signal.aps1.dev.rho.jiohs.net/reports/version',
    frontlineUrl: 'https://rho-dev.noc.plume.com',
    idps: [
      {
        clientId: '0oavrmoxh60cD0nYF357',
      },
    ],
  },
  {
    id: 'rho',
    name: 'Rho',
    graphqlUrl: 'https://signal.aps1.prod.rho.jiohs.net/graphql/',
    backendUrl: 'https://signal.aps1.prod.rho.jiohs.net',
    oktaIssuer: 'https://external.sso.plume.com/oauth2/default',
    oktaBaseUrl: 'https://external.sso.plume.com',
    oktaClientId: '0oatuf6hcahFWCzSy357',
    versionApiEndpoint:
      'https://signal.aps1.prod.rho.jiohs.net/reports/version',
    frontlineUrl: 'https://rho.noc.plume.com',
    idps: [
      {
        clientId: '0oavrmoxh60cD0nYF357',
      },
    ],
  },
];

// function to lookup the deployment string from the URL, will return null if URL not compliant or not found
export const getEnvironment = (): Environment | undefined => {
  if (typeof window === 'undefined') {
    return environments.find(({ id }) => id === 'local');
  }
  const hostnameBits = window.location.hostname.split('.');
  if (hostnameBits.length > 3) {
    // new URLS of kappa.signal.plume.com
    const envFromUrl = hostnameBits[hostnameBits.length - 4];

    for (const env of environments) {
      if (env.id === envFromUrl) {
        return env; // possible future enhancement to hold in store
      }
    }
    return undefined; // not found
  } else {
    // old URLs of signal.plume.com or localhost
    return localEnv;
  }
};

const getEnvProp = (propName: EnvironmentProp, fallbackValue: string) => {
  const env = getEnvironment();
  return (env && env[propName]) || fallbackValue;
};

export const isRegionSpecificSignal = () => {
  return getEnvironment() ? true : false;
};

export const isRhoRegionalSignal = () => {
  const env = getEnvironment();
  return ['rho', 'rho-dev'].includes(env?.id || '');
};

export const isRhoOrCiSignal = () => {
  const env = getEnvironment();
  return ['ci', 'rho', 'rho-dev'].includes(env?.id || '');
};

export const getIDPs = () => {
  const env = getEnvironment();
  if (env?.idps) {
    return env.idps;
  }
  return [];
};

export const getSphereName = () => {
  return getEnvProp('name', SIGNAL_ENDPOINT_SPHERE);
};

export const getBackendUrl = () => {
  return getEnvProp('backendUrl', VERSION_ENDPOINT);
};

export const getGraphqlUrl = () => {
  return getEnvProp('graphqlUrl', SIGNALGRAPHQL_ENDPOINT);
};

export const getOktaClientId = () => {
  return getEnvProp('oktaClientId', OKTA_CLIENT_ID);
};

export const getOktaBaseUrl = () => {
  return getEnvProp('oktaBaseUrl', OKTA_BASE_URL);
};

export const getOktaIssuer = () => {
  return getEnvProp('oktaIssuer', OKTA_ISSUER);
};

export const getVersionApiEndpoint = () => {
  return getEnvProp('versionApiEndpoint', VERSION_ENDPOINT);
};

export const getFrontlineUrl = () => {
  return getEnvProp('frontlineUrl', '');
};
